export default __webpack_public_path__ + "static/media/related-post-01.f19969fd.jpg";